import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { ContentCard } from '../ContentCard';
import { useContentCarousel } from '../../../../hooks/useContentCaroousel';

import 'swiper/css';
import styles from './ContentCarousel.module.scss';

export const ContentCarousel: React.FC = () => {
  const { slidesToRender, visibleContent, slidesCount, isCarousel } = useContentCarousel();

  if (!slidesCount) return null;

  if (!isCarousel) {
    return (
      <section className={styles.carouselContainer}>
        <ContentCard content={visibleContent[0]} priority />
      </section>
    );
  }

  return (
    <section className={styles.carouselContainer}>
      <Swiper
        modules={[Autoplay]}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        className={styles.mySwiper}
      >
        {slidesToRender.map((content, index) => (
          <SwiperSlide key={`${content.id}-${index}`} className={styles.swiperSlide}>
            <ContentCard content={content} priority={index === 0} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};
